<template>
    <AppLayout>
        <router-view></router-view>
    </AppLayout>
</template>

<script>
/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require("axios");
window.axios.defaults.withCredentials = true;
window.axios.defaults.headers.common = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
};

import AppLayout from "@/layouts/AppLayout";
export default {
    name: "App",
    components: { AppLayout },
};
</script>

<style lang="scss">
@use "@scss/vselect.scss" as *;
@use "@scss/inline-edit-input.scss" as *;
</style>
